var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useCallback, useMemo } from 'react';
import Page from '@Components/Page';
import ResponsiveAppBar from '@Components/Header';
import Box from '@mui/material/Box';
import AppSettings from './components/app';
import Profile from './components/profile';
import SideMenu from './components/sideMenu';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
export var Settings = function () {
    var _a = useState(1), selectedIndex = _a[0], setSelectedIndex = _a[1];
    var items = [
        {
            id: 1,
            name: 'Perfil banco',
            icon: _jsx(AccountCircleIcon, {}),
            component: _jsx(Profile, {}),
        },
        {
            id: 2,
            name: 'Aplicación',
            icon: _jsx(PhoneIphoneIcon, {}),
            component: _jsx(AppSettings, {}),
        },
    ];
    var handleListItemClick = useCallback(function (index) {
        if (items.some(function (item) { return item.id === index; })) {
            setSelectedIndex(index);
        }
    }, [items]);
    var selectedItem = useMemo(function () { return items.find(function (item) { return item.id === selectedIndex; }); }, [items, selectedIndex]);
    return (_jsxs(Page, { children: [_jsx(ResponsiveAppBar, {}), _jsxs(Box, __assign({ sx: { display: 'flex', flexGrow: 1, padding: '10px 40px' } }, { children: [_jsx(SideMenu, { sections: items, activeSectionId: selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.id, onSectionClick: handleListItemClick }), _jsx(Box, __assign({ sx: { flexGrow: 1, p: 2 } }, { children: selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.component }))] }))] }));
};
